import { render } from "./DefaultStat.vue?vue&type=template&id=f5499a24"
import script from "./DefaultStat.vue?vue&type=script&lang=js"
export * from "./DefaultStat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__